import { Size } from "./types";
import { StyledLabel } from "./StyledLabel";

import type { FunctionComponent } from "react";

export const ButtonLabel: FunctionComponent<{
	label: string;
	size: Size;
	disabled?: boolean;
	weight?: string;
}> = ({ label, size, disabled, weight, }) => {
	return (
		<StyledLabel size={size} disabled={disabled} weight={weight}>
			{label}
		</StyledLabel>
	);
};
